module.exports = __webpack_public_path__ + "static/media/atmosphere-calm-casual-svgrepo-com.29f067f7.svg";